// src/utils/transferModes.js
import { SUBSTITUTION_KIND_LIST } from "./constants";

/**
 * Опции поводов замещения. Отпуск здесь — обычный повод, наравне с
 * командировкой и ротацией: запись создаётся вручную и живёт отдельно
 * от vacation-сущности.
 */
export const SUBSTITUTION_KIND_OPTIONS = Object.freeze(
  SUBSTITUTION_KIND_LIST.filter((kind) => kind.delegated === true).map(
    (kind) => ({ value: kind.value, label: kind.label }),
  ),
);
